import React, { useState, useCallback } from "react";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from "react-google-recaptcha-v3";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    postcode: "",
    message: "",
  });
  
  const [formDisabled, setFormDisabled] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const [errorOccurred, setErrorOccurred] = useState(false); // Track if backend fails
  const [loading, setLoading] = useState(false); // Track button "Sending..." state
  const [recaptchaValue, setRecaptchaValue] = useState("");

  const { name, email, phoneNumber, postcode, message } = formData;

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  const handleVerify = useCallback((token) => {
    setRecaptchaValue(token);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorOccurred(false); // Reset error state on new click

    if (!recaptchaValue) {
      alert("Please wait for reCAPTCHA to load.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, recaptchaValue }),
      });

      if (response.ok) {
        setFormData({
          name: "",
          email: "",
          phoneNumber: "",
          postcode: "",
          message: "",
        });
        setFormDisabled(true);
        setMessageSent(true);
      } else {
        // This catches 400 or 500 errors from your backend
        throw new Error("Server rejected the request");
      }
    } catch (err) {
      console.error("Submission error:", err);
      setErrorOccurred(true); // This triggers the "Call Us" box
    } finally {
      setLoading(false); // Stop the "Sending..." button state
    }
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
      <section id="contact">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2>Contact</h2>
              <hr className="star-primary" />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 col-lg-offset-2">
              <form id="contactForm" onSubmit={handleSubmit}>
                
                {/* Name Field */}
                <div className="row control-group">
                  <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label htmlFor="nameInput">Name</label>
                    <input id="nameInput" type="text" placeholder="Your Name" name="name" value={name} onChange={handleChange} required disabled={formDisabled} />
                  </div>
                </div>

                {/* Email Field */}
                <div className="row control-group">
                  <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label htmlFor="emailInput">Email</label>
                    <input id="emailInput" type="email" placeholder="Email" name="email" value={email} onChange={handleChange} required disabled={formDisabled} />
                  </div>
                </div>

                {/* Phone Field */}
                <div className="row control-group">
                  <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label htmlFor="phoneNumberInput">Phone Number</label>
                    <input id="phoneNumberInput" type="tel" placeholder="Phone Number" name="phoneNumber" value={phoneNumber} onChange={handleChange} required disabled={formDisabled} />
                  </div>
                </div>

                {/* Postcode Field */}
                <div className="row control-group">
                  <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label htmlFor="postcodeInput">Postcode</label>
                    <input id="postcodeInput" type="text" placeholder="Postcode" name="postcode" value={postcode} onChange={handleChange} required disabled={formDisabled} />
                  </div>
                </div>

                {/* Message Field */}
                <div className="row control-group">
                  <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label htmlFor="messageInput">Message</label>
                    <textarea id="messageInput" rows={3} placeholder="Message" name="message" value={message} onChange={handleChange} required disabled={formDisabled} style={{ resize: "none", margin: "auto" }} />
                  </div>
                </div>

                <GoogleReCaptcha onVerify={handleVerify} />

                <div className="row">
                  <br />
                  <div className="form-group col-xs-12">
                    <button
                      className={`btn btn-lg ${errorOccurred ? 'btn-danger' : 'btn-success'}`}
                      type="submit"
                      disabled={formDisabled || loading}
                    >
                      {loading ? "Sending..." : "Send"}
                    </button>
                  </div>
                </div>

                {/* SUCCESS UI */}
                {messageSent && (
                  <div id="success" style={{ marginTop: '20px', padding: '15px', backgroundColor: '#dff0d8', borderRadius: '4px' }}>
                    <p><strong>Message is sent!</strong></p>
                    <p>Thank you for contacting us. We will get back to you shortly.</p>
                  </div>
                )}

                {/* ERROR UI (THE "CALL US" BOX) */}
                {errorOccurred && (
                  <div id="error" style={{ marginTop: '20px', padding: '20px', border: '2px solid #d9534f', borderRadius: '4px', backgroundColor: '#f2dede', color: '#a94442' }}>
                    <p><strong>Error: Something went wrong on our end.</strong></p>
                    <p>Your message wasn't sent. Please contact us directly:</p>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                      <li><strong>Free:</strong> 0800 619 06 15</li>
                      <li><strong>Mobile:</strong> 07724 282924</li>
                      <li><strong>Email:</strong> ginascleaningser@gmail.com</li>
                    </ul>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </GoogleReCaptchaProvider>
  );
};

export default Contact;